import React, { useState } from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import { FormattedMessage } from "react-intl";

/**
 * Expandable
 *
 * @param {Element} children
 * @param {Function} onToggle - Callback when expanded state changes
 */
const Expandable = ({ children, onToggle, ...props }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);

    if (onToggle) {
      onToggle(newState);
    }
  };

  return (
    <div css={styles.container} {...props}>
      <div css={styles.label}>
        <button css={styles.button} onClick={handleToggle}>
          <FormattedMessage id={isExpanded ? `Global.ShowLess` : `Global.ShowMore`} />
          <Icon
            type={isExpanded ? ICON_TYPE.chevronUp : ICON_TYPE.chevronDown}
            size={ICON_SIZE.small}
            color={colors.grayAnatomyBase}
          />
        </button>
      </div>
      {isExpanded && <div>{children}</div>}
    </div>
  );
};

const styles = {
  label: css`
    padding: 1rem 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:after,
    &:before {
      content: "";
      display: inline-block;
      border-bottom: 1px ${colors.grayAnatomyLight3} dashed;
      flex: 1;
    }
  `,
  button: css`
    border: 0;
    padding: 0 1rem;
    background: none;
    font-size: ${fontSize.small};
    font-weight: 600;
    color: ${colors.grayAnatomyBase};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  `,
};

Expandable.propTypes = {
  children: PropTypes.element,
  onToggle: PropTypes.func,
};

export default Expandable;
